.text {
  // font-family: 'IBM Plex Sans', sans-serif;
  line-height: 1;
}
